import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { Chart, ChartConfiguration } from 'chart.js/auto';

@Component({
  standalone: true,
  selector: 'app-chart-card',
  imports: [CommonModule, CardModule],
  templateUrl: './chart-card.component.html',
  styleUrl: './chart-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartCardComponent implements AfterViewInit, OnChanges, OnDestroy {
  
  @Input() chartContent!: ChartConfiguration;
  @Input() title: string = '';

  @ViewChild('chartCanvas') private chartCanvas!: ElementRef<HTMLCanvasElement>;

  private chart: Chart | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    // Re-render chart if chartContent changes and the view is initialized.
    if (changes['chartContent'] && !changes['chartContent'].isFirstChange() && this.chartCanvas?.nativeElement) {
      this.renderChart();
    }
  }

  ngAfterViewInit(): void {
    // Initial render after the view and canvas element are ready.
    this.renderChart();
  }

  ngOnDestroy(): void {
    // Clean up the chart instance to prevent memory leaks.
    this.chart?.destroy();
  }

  private renderChart(): void {
    if (!this.chartContent || !this.chartCanvas?.nativeElement) {
      return;
    }

    this.chart?.destroy();

    this.chart = new Chart(this.chartCanvas.nativeElement, this.chartContent);
  }
}